import { useTranslation } from "react-i18next";
import TestCaseRightIcon from "../../../../utils/Images/TestCaseRightIcon";
import TestCaseWrongIcon from "../../../../utils/Images/TestCaseWrongIcon";
import {
  convertToText,
  formatSummaryTitle,
} from "../../../../utils/Common/Constant";
import CodeMirror from "@uiw/react-codemirror";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";
import { ResponseScreenEnums } from "../../../../utils/Enums/ResponseScreenEnums";
import { capitalizeFirstLetter } from "../../../../utils/Common/Constant";
import DataNotAvailable from "../../../../utils/DataNotFound/DataNotAvailable";
interface CodingTypeProps {
  answerData: any;
}
const CodingType: React.FC<CodingTypeProps> = ({ answerData }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="codAnswerLabel">{t("RESPONSE_LIST.ANSWER")} :</div>
      <div className="row codeMain mt-3">
        <div className="col-lg-6 codeditor">
          <CodeMirror
            value={convertToText(answerData?.response?.answer)}
            height="400px"
            theme={vscodeDark}
            editable={false}
            readOnly={true}
          />
        </div>
        <div className="col-lg-6 testCaseWithResult">
          <div className="tabChange">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
                tabIndex={0}
              >
                <div className="testCaseFrame">
                  {Array.isArray(answerData?.response?.meta) &&
                  answerData.response.meta.length > 0 ? (
                    <div className="testcases">
                      <span className="codeHeading">
                        {t("RESPONSE_LIST.TESTCASES")}
                      </span>
                      {answerData?.response?.meta?.map(
                        (list: any, index: number) => {
                          return (
                            <div
                              key={index}
                              className="testcase"
                              style={{
                                border:
                                  list?.status ===
                                  ResponseScreenEnums.TESTCASE_PASS
                                    ? "1px solid var(--secondary-green)"
                                    : "1px solid var(--fail-pink)",
                              }}
                            >
                              <div className="testCaseTitle">
                                <span className="">
                                  {t("GENERAL.TEST_CASE")} {index + 1}
                                </span>
                                <br />
                                <span className="testCaseLabels">
                                  {t("GENERAL.INPUT")}
                                </span>
                                <br />
                                <span>{list?.input}</span>
                                <br />
                                <span className="testCaseLabels">
                                  {t("GENERAL.OUTPUT")}
                                </span>
                                <br />
                                <span>{list?.actual_output}</span>
                                <br />
                                <span className="testCaseLabels">
                                  {t("GENERAL.EXPECTED_OUTPUT")}
                                </span>
                                <br />
                                <span>{list?.expected_output}</span>
                              </div>
                              <div
                                style={{
                                  background:
                                    list?.status ===
                                    ResponseScreenEnums.TESTCASE_PASS
                                      ? "var(--secondary-green)"
                                      : "var(--fail-pink)",
                                }}
                                className="icon"
                              >
                                {list?.status ===
                                ResponseScreenEnums.TESTCASE_PASS ? (
                                  <TestCaseRightIcon />
                                ) : (
                                  <TestCaseWrongIcon />
                                )}
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  ) : answerData?.meta?.summary ? (
                    <div className="summaryFeedback">
                      <span className="summaryHeading">
                        {t("RESPONSE_LIST.SUMMARY")}
                      </span>
                      <div className="summaryObject">
                        <ul className="summaryList">
                          {Object.entries(answerData.meta.summary)
                            .filter(
                              ([key]) =>
                                key !== "user_output" &&
                                key !== "code_correctness",
                            )
                            .map(([key, value]) => (
                              <li className="summaryText" key={key}>
                                <span className="summaryKey">
                                  {formatSummaryTitle(key)}:
                                </span>
                                <span className="summaryValue">
                                  {" "}
                                  {capitalizeFirstLetter(String(value))}
                                </span>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div className="noData">
                      <DataNotAvailable />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodingType;
